<template>
  <div class="combobox-wrapper">
    <v-combobox
      v-model="internalValue"
      variant="outlined"
      :label="t('Language')"
      :items="items"
      :readonly="readonly"
      item-title="raw"
      item-value="raw"
      :menu-props="{ attach: '#approot' }"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  modelValue: { type: [String, Object], default: null },
  items: { type: Array, default: () => [] },
  readonly: { type: Boolean, default: false },
})

const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const emit = defineEmits(['update:modelValue'])
</script>

<style lang="scss">
.combobox-wrapper {
  & > .v-text-field--outlined > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-secondary));
  }
  & > .v-text-field--outlined.v-input--is-focused > .v-input__control > .v-field__input,
  & > .v-text-field--outlined.v-input--is-dirty > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-white));
  }
}
</style>
